import Vue from 'vue'
import App from './App.vue'
import { createAxiosInstance } from './AxiosInstance'  // Updated import
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

store.dispatch("restoreSession");

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister();
    });
  });
}

// Dynamically load config.json and initialize Axios
async function bootstrapApp() {
  try {
    const axiosInstance = await createAxiosInstance();
    Vue.prototype.$http = axiosInstance;

    Vue.config.productionTip = false;

    new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app');
  } catch (error) {
    console.error('Failed to initialize app:', error);
  }
}

bootstrapApp();
